import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmpty } from "lodash";
import Breadcrumbs from "./Breadcrumbs";
import Container from "./Container";
import { useLayoutContext } from "./context";
const BodyHeader = ({ children }) => _jsx("div", { children: children });
const BodyFooter = ({ children }) => _jsx("div", { children: children });
const Body = ({ children, style, className, id }) => {
    const { listBreadcrumbs } = useLayoutContext();
    return (_jsxs("main", { id: id, className: `layout__body te-flex te-flex-col te-flex-auto te-min-h-0 ${className} te-bg-main-background-color`, style: style || {}, children: [!isEmpty(listBreadcrumbs) && (_jsx("div", { className: "te-pt-6 te-pb-4", children: _jsx(Container, { children: _jsx(Breadcrumbs, { items: listBreadcrumbs }) }) })), _jsx("div", { className: "te-flex te-flex-col te-flex-auto te-overflow-auto scrollable", children: children })] }));
};
export { BodyHeader, BodyFooter };
export default Body;
